import { BaseURL } from "../../config/axios";
import { getCategorys } from "../../api-route/categorys";
import { useEffect, useRef, useState } from "react";
import { Pagination } from "@nextui-org/react";
import paginationHelper from "../../helper/paginationHelper";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import CircularProgress from '@mui/joy/CircularProgress';


export default function CategoriesSection({ head1, head2 }) {
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page') || 1;
  const navigate = useNavigate();

  const pagination = useRef()
  const [data, setData] = useState([])

  useEffect(() => {
    const get = async () => {
      const data = await getCategorys({ page });
      setData(data ? data : [])
      pagination.current = data ? Math.ceil(data.total / data.per_page) : 1
    }
    get()
  }, [page])

  const handlePage = (page) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', page);
    navigate({ search: `?${newParams.toString()}` }, { replace: true });
    paginationHelper()
  }

  return (
    <div className="text-center my-12" dir="rtl">
      <div className="container">
        {head1 && <h3 className="title text-primary mb-6">{head1}</h3>}
        {head2 && <h5 className="text-red-900 mb-6">{head2}</h5>}
        {
          data.length === 0 ? <CircularProgress color="danger" /> :
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 w-full gap-6">
            
            {data.map((item) => {
              return <GenreItem {...item} key={item.id} />;
            })}
          </div>
        }
        <div dir="auto" className="centerOfParent mt-4">
          {!!data.length && pagination.current > 1 &&
            <Pagination size='sm'
              total={Math.ceil(pagination.current)}
              color="primary"
              page={Number(page)}
              onChange={handlePage}
              showControls
            />}
        </div>
      </div>
    </div>
  );
}

function GenreItem({ baner, title, id, slug }) {
  return (
    <>
      <Link
        to={"/categories/" + slug}
        className="relative h-80 overflow-hidden *:transition-all *:duration-300 *:ease-in-out group"
      >
        <div
          className="group-hover:scale-110"
        ><img className="w-full h-auto object-contain" placeholder='blur' blurDataURL='/images/placeholder-1.png'
          width={100} height={100} src={BaseURL + baner[0]?.path} alt={title} title={title} /></div>
        <div className="absolute inset-x-0 bottom-0 group-hover:bg-opacity-75 bg-slate-800 text-white p-2">
          {title}
        </div>
      </Link>
    </>
  );
}
